// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickViewCard_quick-card__lyhfo {
  display: flex;
  width: 750px;
  max-width: 100%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.QuickViewCard_quick-card__lyhfo:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 0.98);
  border-color: rgba(30, 58, 95, 0.2);
}
.QuickViewCard_quick-card__checkbox__\\+2Ats {
  display: flex;
  align-items: center;
  padding: 4px 0 0 12px;
}
.QuickViewCard_quick-card__checkbox__\\+2Ats input[type=checkbox] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--accent-color);
}
.QuickViewCard_quick-card__left__yJ9\\+j {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 20px 0;
  min-width: 80px;
}
.QuickViewCard_quick-card__rank__xZ-Ll {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}
.QuickViewCard_quick-card__center__o5Roe {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 20px 16px;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  min-width: 0;
}
.QuickViewCard_quick-card__header__OpCbE {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.QuickViewCard_quick-card__name-block__Jvxw0 {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.QuickViewCard_quick-card__logo__ulsBC {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: var(--accent-color-light);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: var(--accent-color);
  flex-shrink: 0;
}
.QuickViewCard_quick-card__logo-img__4ItAd {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}
.QuickViewCard_quick-card__title__nNhR- {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.QuickViewCard_quick-card__full-name__sQ7-F {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-1);
  overflow: hidden;
  text-overflow: ellipsis;
}
.QuickViewCard_quick-card__meta__JBY7m {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.QuickViewCard_quick-card__meta__JBY7m span {
  font-size: 12px;
  color: var(--grey-text);
}
.QuickViewCard_quick-card__tags__K0X7D {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.QuickViewCard_quick-card__tag__Dlbf- {
  padding: 4px 14px;
  border-radius: 20px;
  border: 1.5px solid var(--accent-color-medium);
  font-size: 12px;
  font-weight: 600;
  color: var(--accent-color);
  background: transparent;
  cursor: default;
}
.QuickViewCard_quick-card__right__J8iiY {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  padding: 20px 24px;
  min-width: 280px;
}
.QuickViewCard_quick-card__metrics__xYKpY {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 24px;
  margin-bottom: 8px;
}
.QuickViewCard_quick-card__metric__YrvhA {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.QuickViewCard_quick-card__metric-label__6JOS1 {
  font-size: 11px;
  color: var(--grey-text);
  white-space: nowrap;
}
.QuickViewCard_quick-card__metric-value__zDWeK {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-1);
  line-height: 1.2;
}
.QuickViewCard_quick-card__metric-value__zDWeK sub {
  font-size: 10px;
  font-weight: 400;
  color: var(--grey-text);
  margin-left: 2px;
  vertical-align: baseline;
}
.QuickViewCard_quick-card__bar-section__DEGUh {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.QuickViewCard_quick-card__bar-labels__9amv0 {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: var(--grey-text);
}
.QuickViewCard_quick-card__bar__Umw3D {
  width: 100%;
  height: 6px;
  background: #e8edf2;
  border-radius: 3px;
  overflow: hidden;
}
.QuickViewCard_quick-card__bar-fill__-vjPF {
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #0f3460, #4a6fa5);
  transition: width 0.6s ease;
}

@media only screen and (max-width: 900px) {
  .QuickViewCard_quick-card__lyhfo {
    flex-direction: column;
  }
  .QuickViewCard_quick-card__left__yJ9\\+j {
    flex-direction: row;
    min-width: initial;
    padding: 16px;
    gap: 12px;
  }
  .QuickViewCard_quick-card__center__o5Roe {
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
  .QuickViewCard_quick-card__right__J8iiY {
    min-width: initial;
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Benchmarking/Components/QuickViewCard/QuickViewCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,iDAAA;AACF;AACE;EACE,2BAAA;EACA,0CAAA;EACA,qCAAA;EACA,mCAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAAN;AAKE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,MAAA;EACA,eAAA;EACA,eAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAJJ;AAQE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;AANJ;AASE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AATJ;AAYE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,cAAA;AAVJ;AAaE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAXJ;AAcE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AAZJ;AAeE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAbJ;AAeI;EACE,eAAA;EACA,uBAAA;AAbN;AAiBE;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAfJ;AAkBE;EACE,iBAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;AAhBJ;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AApBJ;AAsBI;EACE,eAAA;EACA,uBAAA;EACA,mBAAA;AApBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AArBN;AAuBM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;AArBR;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,uBAAA;AAzBJ;AA4BE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA1BJ;AA4BI;EACE,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,2BAAA;AA1BN;;AAgCA;EACE;IACE,sBAAA;EA7BF;EA+BE;IACE,mBAAA;IACA,kBAAA;IACA,aAAA;IACA,SAAA;EA7BJ;EAgCE;IACE,kBAAA;IACA,4CAAA;EA9BJ;EAiCE;IACE,kBAAA;IACA,aAAA;EA/BJ;AACF","sourcesContent":[".quick-card {\n  display: flex;\n  width: 750px;\n  max-width: 100%;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    background: rgba(255, 255, 255, 0.98);\n    border-color: rgba(30, 58, 95, 0.2);\n  }\n\n  &__checkbox {\n    display: flex;\n    align-items: center;\n    padding: 4px 0 0 12px;\n\n    input[type=\"checkbox\"] {\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n      accent-color: var(--accent-color);\n    }\n  }\n\n  // ---------- LEFT: rank ----------\n  &__left {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0;\n    padding: 20px 0;\n    min-width: 80px;\n  }\n\n  &__rank {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 56px;\n    height: 56px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);\n    color: #fff;\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  // ---------- CENTER: info ----------\n  &__center {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 10px;\n    padding: 20px 16px;\n    border-right: 1px solid rgba(0, 0, 0, 0.06);\n    min-width: 0;\n  }\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  &__name-block {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  &__logo {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    background: var(--accent-color-light);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--accent-color);\n    flex-shrink: 0;\n  }\n\n  &__logo-img {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    object-fit: contain;\n    background: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    flex-shrink: 0;\n  }\n\n  &__title {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  &__full-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-1);\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__meta {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    span {\n      font-size: 12px;\n      color: var(--grey-text);\n    }\n  }\n\n  &__tags {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  &__tag {\n    padding: 4px 14px;\n    border-radius: 20px;\n    border: 1.5px solid var(--accent-color-medium);\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--accent-color);\n    background: transparent;\n    cursor: default;\n  }\n\n  // ---------- RIGHT: metrics ----------\n  &__right {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 14px;\n    padding: 20px 24px;\n    min-width: 280px;\n  }\n\n  &__metrics {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px 24px;\n    margin-bottom: 8px;\n  }\n\n  &__metric {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    &-label {\n      font-size: 11px;\n      color: var(--grey-text);\n      white-space: nowrap;\n    }\n\n    &-value {\n      font-size: 18px;\n      font-weight: 700;\n      color: var(--text-1);\n      line-height: 1.2;\n\n      sub {\n        font-size: 10px;\n        font-weight: 400;\n        color: var(--grey-text);\n        margin-left: 2px;\n        vertical-align: baseline;\n      }\n    }\n  }\n\n  &__bar-section {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__bar-labels {\n    display: flex;\n    justify-content: space-between;\n    font-size: 11px;\n    color: var(--grey-text);\n  }\n\n  &__bar {\n    width: 100%;\n    height: 6px;\n    background: #e8edf2;\n    border-radius: 3px;\n    overflow: hidden;\n\n    &-fill {\n      height: 100%;\n      border-radius: 3px;\n      background: linear-gradient(90deg, #0f3460, #4a6fa5);\n      transition: width 0.6s ease;\n    }\n  }\n}\n\n// ---------- responsive ----------\n@media only screen and (max-width: 900px) {\n  .quick-card {\n    flex-direction: column;\n\n    &__left {\n      flex-direction: row;\n      min-width: initial;\n      padding: 16px;\n      gap: 12px;\n    }\n\n    &__center {\n      border-right: none;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    }\n\n    &__right {\n      min-width: initial;\n      padding: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quick-card": `QuickViewCard_quick-card__lyhfo`,
	"quick-card__checkbox": `QuickViewCard_quick-card__checkbox__+2Ats`,
	"quick-card__left": `QuickViewCard_quick-card__left__yJ9+j`,
	"quick-card__rank": `QuickViewCard_quick-card__rank__xZ-Ll`,
	"quick-card__center": `QuickViewCard_quick-card__center__o5Roe`,
	"quick-card__header": `QuickViewCard_quick-card__header__OpCbE`,
	"quick-card__name-block": `QuickViewCard_quick-card__name-block__Jvxw0`,
	"quick-card__logo": `QuickViewCard_quick-card__logo__ulsBC`,
	"quick-card__logo-img": `QuickViewCard_quick-card__logo-img__4ItAd`,
	"quick-card__title": `QuickViewCard_quick-card__title__nNhR-`,
	"quick-card__full-name": `QuickViewCard_quick-card__full-name__sQ7-F`,
	"quick-card__meta": `QuickViewCard_quick-card__meta__JBY7m`,
	"quick-card__tags": `QuickViewCard_quick-card__tags__K0X7D`,
	"quick-card__tag": `QuickViewCard_quick-card__tag__Dlbf-`,
	"quick-card__right": `QuickViewCard_quick-card__right__J8iiY`,
	"quick-card__metrics": `QuickViewCard_quick-card__metrics__xYKpY`,
	"quick-card__metric": `QuickViewCard_quick-card__metric__YrvhA`,
	"quick-card__metric-label": `QuickViewCard_quick-card__metric-label__6JOS1`,
	"quick-card__metric-value": `QuickViewCard_quick-card__metric-value__zDWeK`,
	"quick-card__bar-section": `QuickViewCard_quick-card__bar-section__DEGUh`,
	"quick-card__bar-labels": `QuickViewCard_quick-card__bar-labels__9amv0`,
	"quick-card__bar": `QuickViewCard_quick-card__bar__Umw3D`,
	"quick-card__bar-fill": `QuickViewCard_quick-card__bar-fill__-vjPF`
};
export default ___CSS_LOADER_EXPORT___;
